'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CalendarDay = {};

exports.__exports = CalendarDay;
